export default "assets/images/home-shape-310ee1b5.svg";